"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RootScopeService = void 0;
const angularjs_service_upgrade_enum_1 = require("../angularjs-service-upgrade.enum");
const rxjs_1 = require("rxjs");
const i0 = __importStar(require("@angular/core"));
class RootScopeService {
    constructor(_rootScope) {
        this._rootScope = _rootScope;
        this.rootScope = new rxjs_1.BehaviorSubject({});
        this.rootScopeObservable = this.rootScope.asObservable();
    }
    updateScope(property, value) {
        this._rootScope.$broadcast(property, value);
    }
    detectScopeChanges(property) {
        this._rootScope.$on(property, () => {
            var _a, _b;
            this.rootScope.next({ [property]: (_b = (_a = this._rootScope) === null || _a === void 0 ? void 0 : _a[property]) !== null && _b !== void 0 ? _b : true });
            this.removeScopeChanges(property);
        });
    }
    removeScopeChanges(property) {
        this.rootScope.next({ [property]: false });
    }
}
exports.RootScopeService = RootScopeService;
RootScopeService.ɵfac = function RootScopeService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || RootScopeService)(i0.ɵɵinject(angularjs_service_upgrade_enum_1.ANGULARJS_SERVICE_UPGRADE_TOKENS.ROOT_SCOPE_TOKEN)); };
RootScopeService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: RootScopeService, factory: RootScopeService.ɵfac, providedIn: 'root' });
